import Immutable from 'immutable';
import { useCallback } from 'react';
import memoizeOne from 'react-utils/memoizeOne';
import { resolveReportMeta } from 'reporting-snowflake/relational/metadata/report-meta';
import { asTable } from 'reporting-snowflake/relational/utils/report-utils';
import usePromiseEffect from '../../shared/hooks/usePromiseEffect';
const haveSameStagedData = (prev, next) => {
  const toSet = listOfColumns => listOfColumns.map(column => column.delete('name').delete('alias')).toSet();
  const prevSet = toSet(prev);
  const nextSet = toSet(next);
  return prevSet.isSuperset(nextSet);
};
const metaRequirementsAreEquivalent = (prev, next) => {
  const columnsHaveSameDataRequirements = prev.columns.map(column => column.delete('name')).equals(next.columns.map(column => column.delete('name')));
  const expressionsHaveSameDataRequirements = prev.expressions.map(expression => expression.delete('alias')).equals(next.expressions.map(expression => expression.delete('alias')));
  const reportsHaveSameStagedData = haveSameStagedData(prev.stagedColumns, next.stagedColumns);
  const tablesAreEqual = prev.table.equals(next.table);

  // only compare filtering logic, groups, and condition
  const filteringIsEqual = Immutable.is(prev.filtering && prev.filtering.delete('stagedFilters'), next.filtering && next.filtering.delete('stagedFilters'));
  return columnsHaveSameDataRequirements && expressionsHaveSameDataRequirements && tablesAreEqual && filteringIsEqual && reportsHaveSameStagedData;
};
export const useReportForMeta = reportDefinition => {
  /* eslint-disable react-hooks/exhaustive-deps */
  const memoizedCreateReportToResolve = useCallback(memoizeOne(report => report, (a, b) =>
  // why $tsMigrationAny: `memoizeOne` incorrectly types this callback as (a: unknown, b: unknown) => boolean
  metaRequirementsAreEquivalent(a, b)), []);
  const reportToResolve = asTable(reportDefinition);
  return memoizedCreateReportToResolve(reportToResolve);
};
const useMeta = reportDefinition => {
  const reportForMeta = useReportForMeta(reportDefinition);
  // todo add additional memoization if needed: check if referenced fields / tables changed to warrant a refetch
  const promise = useCallback(() => {
    return resolveReportMeta(reportForMeta);
  }, [reportForMeta]);
  return usePromiseEffect(promise);
};
export default useMeta;